'use client';

import { useEffect } from 'react';

export default function ClientErrorCapture() {
  useEffect(() => {
    // Capture JavaScript errors
    const handleError = (event: ErrorEvent) => {
      console.error('[JAVASCRIPT ERROR]', {
        message: event.message,
        filename: event.filename,
        line: event.lineno,
        column: event.colno,
        stack: event.error?.stack,
      });

      fetch('/api/log-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'javascript_error',
          message: event.message,
          url: event.filename,
          line: event.lineno,
          column: event.colno,
          stack: event.error?.stack,
          timestamp: new Date().toISOString(),
        }),
      }).catch((error) => {
        console.error('[ERROR REPORTING FAILED]', error);
      });
    };

    // Capture unhandled promise rejections
    const handleUnhandledRejection = (event: PromiseRejectionEvent) => {
      console.error('[UNHANDLED PROMISE REJECTION]', {
        reason: event.reason,
        promise: event.promise,
      });

      fetch('/api/log-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'unhandled_promise_rejection',
          message: event.reason?.toString() || 'Unknown promise rejection',
          stack: event.reason?.stack || null,
          timestamp: new Date().toISOString(),
        }),
      }).catch((error) => {
        console.error('[ERROR REPORTING FAILED]', error);
      });
    };

    // Add event listeners
    window.addEventListener('error', handleError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    // Cleanup
    return () => {
      window.removeEventListener('error', handleError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);

  return null; // This component doesn't render anything
}